<template>
    <div class="home">
        <DataPanel />
        <VideoPanel />
    </div>
</template>

<script>
    // @ is an alias to /src
    import DataPanel from '@/components/DataPanel.vue'
    import VideoPanel from '@/components/VideoPanel.vue'

    import {
        mapState,
        mapActions
    } from 'vuex'

    export default {
        name: 'RobotData',
        components: {
            DataPanel,
            VideoPanel
        },
    }
</script>